import { Card, ChildrenProps } from '@nettbureau/vibrant-ui';
import { ReactNode } from 'react';

interface CardBodyProps extends ChildrenProps {
  children: ReactNode;
}

export function CardBody({ children }: CardBodyProps) {
  return <Card.Body css={{ paddingTop: 0 }}>{children}</Card.Body>;
}
